import React, { ComponentProps, FunctionComponent } from "react";

const PersonasIcon = (
  {
    title,
    titleId,
    ...props
  }: { title?: string; titleId?: string } & React.ComponentProps<"svg">,
  svgRef: any
) => {
  return /*#__PURE__*/ React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 14 12",
        fill: "none",
        "aria-hidden": "true",
        ref: svgRef,
        "aria-labelledby": titleId,
      },
      props
    ),
    title
      ? /*#__PURE__*/ React.createElement(
          "title",
          {
            id: titleId,
          },
          title
        )
      : null,
    /*#__PURE__*/ React.createElement("path", {
      d: "M9.8 12V9.24322C9.8 8.55509 9.54188 7.89514 9.08241 7.40856C8.62295 6.92197 7.99978 6.64861 7.35 6.64861H2.45C1.80022 6.64861 1.17705 6.92197 0.717588 7.40856C0.258124 7.89514 0 8.55509 0 9.24322V12",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("path", {
      d: "M4.9 5.18922C6.2531 5.18922 7.35 4.02758 7.35 2.59461C7.35 1.16165 6.2531 0 4.9 0C3.5469 0 2.45 1.16165 2.45 2.59461C2.45 4.02758 3.5469 5.18922 4.9 5.18922Z",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("path", {
      d: "M12.1333 4.21611C12.1333 5.41025 11.1931 6.37829 10.0333 6.37829C8.87354 6.37829 7.93333 5.41025 7.93333 4.21611C7.93333 3.02198 8.87354 2.05394 10.0333 2.05394C11.1931 2.05394 12.1333 3.02198 12.1333 4.21611Z",
      fill: "currentColor",
    }),

    /*#__PURE__*/ React.createElement("path", {
      d: "M14 9.70269V12H10.8889V9.24323C10.8889 8.61545 10.6707 8.01114 10.278 7.54051H11.9C12.457 7.54051 12.9911 7.76831 13.3849 8.1738C13.7788 8.57929 14 9.12924 14 9.70269Z",
      fill: "currentColor",
    })
  );
};

const ForwardRef = React.forwardRef(PersonasIcon) as FunctionComponent<
  ComponentProps<"svg">
>;

export default ForwardRef;
